import React, { Component } from "react";
import { Card, InputGroup, Button, Container, Row, Col } from "react-bootstrap";
import queryString from "query-string";
import "bootstrap/dist/css/bootstrap.min.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowAltCircleRight, faBinoculars, faSyncAlt} from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import IsoUtcDateTimeToLocalRenderer from "../../AgGridRenderers/IsoUtcDateTimeToLocalRenderer.jsx";
import OrgConfiguration from "../../../models/OrgConfiguration.js";


import ModalAlertDialog from "../../Modals/ModalAlertDialog.jsx";

import moment from "moment";

import GlasschainHttpClient from "../../ApiService/GlasschainHttpClient.js";
import AuthService from "../../AuthService/AuthService.js";

const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";

const columnDefs = 
[
    {headerName: "Receipt", field: "receiptHeader.tagId", sortable: true, filter: true, resizable: true, maxWidth: 100},
    {headerName: "Line", field: "receiptLine.lineNbr", sortable: true, filter: false, resizable: false, maxWidth: 25},  
    {headerName: "Pallets", field: "receiptLine.pallets", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 300, wrapText: true, autoHeight: true, 
      cellRenderer: function(params) 
      {
        var glasschainIds = params.value.map(p => p.glasschainId);
        return glasschainIds.join(", ")
      }
    },
    {headerName: "Block", field: "receiptLine.blockName", sortable: true, filter: false, resizable: true, maxWidth: 300},  
    {headerName:  "Item", field: "receiptLine.itemName", sortable: true, filter: false, resizable: true, maxWidth: 400},
    {headerName:  "Warehouse", field: "receiptHeader.warehouseName", sortable: true, filter: false, resizable: true, maxWidth: 150},
    {headerName:  "Location", field: "receiptHeader.sublocationName", sortable: true, filter: false, resizable: true, maxWidth: 150},
    {headerName:  "Received", field: "receiptHeader.receiveDateTime", sortable: true, filter: false, resizable: true, maxWidth: 250, "cellRenderType": IsoUtcDateTimeToLocalRenderer}
   ];



export default class MraOpenPalletsGridCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gridSchema: [],
      schema: null,
      gridData: [],
      isLoading: true,
      selectedRow: null,
      showAlert : false,
      alertTitle : "",
      alertMessage: "",
      alertType: "info"  // error/warning/info
    };

    this.auth = new AuthService();
    this.httpClient = new GlasschainHttpClient();
    this.gcid = this.auth.getGcid();


    this.refreshGridData = this.refreshGridData.bind(this);
    this.onObserveLinePalletsRequest = this.onObserveLinePalletsRequest.bind(this);
  }

  async componentDidMount() {
    if (this.props.isConnected){
      if (!this.auth.loggedIn()){
        console.log("ObservationsGridCard componentDidMount - not logged in");
        this.props.onSystemLogoutRequest();        
      }
      this.refreshGridData();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.isConnected){
      if (!this.auth.loggedIn()){
        console.log("ObservationsGridCard componentDidUpdate - not logged in");
        this.props.onSystemLogoutRequest();        
      }
    }
    /*
    if (this.props.gridQueryString !== prevProps.gridQueryString) {
      await this.refreshGridData(this.props.gridQueryString);
    }
    */
  }


  showAlertDialog(title, message, type){  //error warning info
    this.setState({alertTitle: title, alertMessage: message, alertType: type, showAlert: true});
  }

  onCloseAlert(){
    this.setState({showAlert: false});
  }


  async refreshGridData() {
    this.setState({ isLoading: true });
    var gridDataResponse = await this.httpClient.fetchOpenMraPallets();
    var newGridData = gridDataResponse.data;
    console.info(newGridData);
    //this.props.onDetailedGridRowChange(null);
    this.setState({
      gridData: newGridData,
      isLoading: false,
    });
  }

  onObserveLinePalletsRequest()
  {
      if (!this.state.selectedRow)
      {
          alert("Please select a line/pallet to inspect!");
          return;
      }
      alert("Not yet implemented.");
  }

  onEditGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // deal with the grid height
    var domLayoutStyle = (this.gridApi.getDisplayedRowCount() > 20) ? 'normal': "autoHeight";
    this.gridApi.setDomLayout(domLayoutStyle);
  };

  onSelectionChanged() {
    var selectedNodes = this.gridApi.getSelectedNodes();
    var rowData = selectedNodes[0].data;
    this.setState({selectedRow: rowData});
    //this.props.onDetailedGridRowChange(rowData);
  }


  render() {
    const loadingIcon = this.state.isLoading ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );

    const divStyle = {
      width: "100%",
      //height: "calc(45vh)",
      margin: "5px",
      //border: '5px solid black'
    };


    const gridData = this.state.gridData ? this.state.gridData : [{}];

    return (

      <span>
        <ModalAlertDialog
          show={this.state.showAlert}
          title={this.state.alertTitle}
          iconType={this.state.alertType} // error|warning|info
          message={this.state.alertMessage}
          onClose={this.onCloseAlert}

        />
      <Card id="historyPanelCard">
        <Card.Header>
          <span style={{ float: "left" }}>Uninspected Receipt Pallets</span>
          <span style={{ float: "right" }}>{loadingIcon}</span>
        </Card.Header>
        <ReactTooltip />
        <Card.Body>
          <div style={{ width: "100%" }}>
            <Container fluid>
                  <InputGroup size="sm">
                    <p data-tip="Refresh Grid">
                      <Button
                        size="sm"
                        variant="outline-info"
                        onClick={this.refreshGridData}
                      >
                        <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        &nbsp;refresh
                      </Button>
                    </p>

                    {/*
                    <p data-tip="Observe Line Pallets">
                      <Button
                        size="sm"
                        variant="outline-info"
                        onClick={this.onObserveLinePalletsRequest}
                      >
                        <FontAwesomeIcon icon={faBinoculars} />
                        &nbsp;Inspect
                      </Button>
                    </p>
                  */}
                  
                  </InputGroup>
            </Container>

            <div className="ag-theme-balham" style={divStyle}>
              <AgGridReact
                rowSelection="single"
                enableRangeSelection={true}
                pagination={true}
                columnDefs={columnDefs}
                rowData={gridData}
                animateRows={true}
                onGridReady={this.onGridReady}
                onSelectionChanged={this.onSelectionChanged.bind(this)}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
      </span>
    );
  }
}
